import vFontIcon from './FontIcon';

export { vFontIcon };


// WEBPACK FOOTER //
// ./src/baseComponents/components/FontIcon/index.js